export default __webpack_public_path__ + "4a9b5e62e17b371d882f1a0baded151b.png";